import { render, staticRenderFns } from "./ofertas-para-pago.vue?vue&type=template&id=be9bf1f0&"
import script from "./ofertas-para-pago.vue?vue&type=script&lang=js&"
export * from "./ofertas-para-pago.vue?vue&type=script&lang=js&"
import style0 from "./ofertas-para-pago.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports